import { SimpleModal } from "frontend/uses/simple-modal/variants/simple-modal";

export class FailureModal extends SimpleModal {
  get defaultTitle(): string {
    return "Fehler";
  }

  get hideCancel() {
    return true;
  }
}
